<template>
  <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
    <v-row>
      <v-col cols="12" sm="12">
        <v-card class="pa-3 rounded-0 elevation-0 mt-6" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
          <v-sheet class="transactionTable liveTradeTable pb-3" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
            <v-data-table :headers="headers" :items="desserts" :items-per-page="6">
              <template v-slot:item.profit="{ item }">
                <span class="profit-text-color">
                  {{ item?.profit }}
                </span>
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
export default {
  data() {
    return {
      headers: [
        { text: "Ticket", value: "ticketNumber", align: "start", },
        {
          text: "Date & Time",
          value: "dataTimes",
        },
        { text: "Type", value: "accountType" },
        { text: "Lots", value: "lots" },
        { text: "Symbol", value: "symbol" },
        { text: "Open", value: "open" },
        { text: "SL-TP", value: "sltp" },
        { text: "Running", value: "running" },
        { text: "Profit", value: "profit" },
      ],
      desserts: [
        {
          ticketNumber: 120,
          dataTimes: "25.08.2020-8:32 pm",
          accountType: "Buy",
          lots: "1:105550",
          symbol: "$",
          open: "$1000",
          sltp: ".10-.20",
          running: "$120",
          profit: "$120",
        },
        {
          ticketNumber: 120,
          dataTimes: "25.08.2020-8:32 pm",
          accountType: "Buy",
          lots: "1:105550",
          symbol: "$",
          open: "$1000",
          sltp: ".10-.20",
          running: "$120",
          profit: "$120",
        },
        {
          ticketNumber: 120,
          dataTimes: "25.08.2020-8:32 pm",
          accountType: "Buy",
          lots: "1:105550",
          symbol: "$",
          open: "$1000",
          sltp: ".10-.20",
          running: "$120",
          profit: "$120",
        },
        {
          ticketNumber: 120,
          dataTimes: "25.08.2020-8:32 pm",
          accountType: "Buy",
          lots: "1:105550",
          symbol: "$",
          open: "$1000",
          sltp: ".10-.20",
          running: "$120",
          profit: "$120",
        },
        {
          ticketNumber: 120,
          dataTimes: "25.08.2020-8:32 pm",
          accountType: "Buy",
          lots: "1:105550",
          symbol: "$",
          open: "$1000",
          sltp: ".10-.20",
          running: "$120",
          profit: "$120",
        },
        {
          ticketNumber: 120,
          dataTimes: "25.08.2020-8:32 pm",
          accountType: "Buy",
          lots: "1:105550",
          symbol: "$",
          open: "$1000",
          sltp: ".10-.20",
          running: "$120",
          profit: "$120",
        },
        {
          ticketNumber: 120,
          dataTimes: "25.08.2020-8:32 pm",
          accountType: "Buy",
          lots: "1:105550",
          symbol: "$",
          open: "$1000",
          sltp: ".10-.20",
          running: "$120",
          profit: "$120",
        },

      ],
    };
  },
};
</script>
